<template>
  <a :href="googleLink" target="_blank" class="btn btn--maps">{{ maps }}</a>
</template>

<script>
export default {
  name: 'GoogleLink',
  props: {
    center: {
      type: Array,
      required: false,
      default: () => ['7.5885761', '47.5595986'],
    },
    maps: {
      type: String,
      required: true,
    },
  },
  computed: {
    googleLink() {
      return `https://www.google.com/maps/search/?api=1&query=${this.center[1]}%2C${this.center[0]}`;
    },
  },
};
</script>
